import { useDispatch, useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import Cookies from "universal-cookie"
import { logOut, setCredentials } from 'features/auth/authSlice';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { axiosInstance } from 'utils/axios';
import {useNavigate} from "react-router"
import "./i18n";
// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);
    const cookies = new Cookies()
    const dispatch = useDispatch()
    const cookie_token = cookies.get("jwt_authorization")

    
    const navigate = useNavigate()

    const errorAlert = (message) => {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER
        });
      };
    

    axiosInstance.interceptors.response.use(response => {
        return response;
     }, error => {
       if (error.response.status === 401) {
        errorAlert("Something went wrong.")
        dispatch(logOut())
        cookies.remove('jwt_authorization')
        navigate("pages/login/login3")
       }
       return error;
    });

    // useEffect(() => {
        if(cookie_token){
            dispatch(setCredentials({user : 'testing01', token :cookie_token}))
        }
    // },[])
    

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                    <ToastContainer/>
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
